"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactInfoType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ContactInfoType_Factory = /** @class */ (function () {
    function ContactInfoType_Factory() {
    }
    ContactInfoType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    ContactInfoType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return ContactInfoType_Factory;
}());
exports.ContactInfoType_Factory = ContactInfoType_Factory;
